import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Spinner,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as _ from "lodash";

import NibbleInput from "../../../components/Fields/NibbleInput";
import {
  findManyConfigurations,
  upsertManyConfigurations,
} from "../../../helpers/backend_helper";

const horizontalConfig = {
  name: "Tamaño de fuente para papeleta horizontal",
  type: "number",
  modulo: "papeleta",
  value_default: 12,
};

const verticalConfig = {
  name: "Tamaño de fuente para papeleta vertical",
  type: "number",
  modulo: "papeleta",
  value_default: 12,
};

const configNames = [horizontalConfig.name, verticalConfig.name].join(",");

const ConfigModal = ({ modal, setModal }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, config: false });
  };

  const onSubmit = (formValues) => {
    const data = {
      configurations: [formValues.horizontalConfig, formValues.verticalConfig],
    };

    setIsLoading(true);
    upsertManyConfigurations(data)
      .then(() => {
        handleClose();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { verticalConfig, horizontalConfig },
    validationSchema: Yup.object({
      horizontalConfig: Yup.object({
        value_default: Yup.number()
          .min(5)
          .max(20)
          .required()
          .label("Fuente horizontal"),
      }),
      verticalConfig: Yup.object({
        value_default: Yup.number()
          .min(5)
          .max(20)
          .required()
          .label("Fuente vertical"),
      }),
    }),
    onSubmit,
  });

  const fetchConfig = () => {
    const config = {
      params: {
        names: configNames,
      },
    };

    findManyConfigurations(config).then((resp) => {
      const horiConfig = _.find(resp, {
        name: horizontalConfig.name,
      });
      const vertiConfig = _.find(resp, {
        name: verticalConfig.name,
      });

      if (horiConfig) {
        validation.setFieldValue(
          "horizontalConfig.value_default",
          horiConfig.value_default
        );
      }

      if (vertiConfig) {
        validation.setFieldValue(
          "verticalConfig.value_default",
          vertiConfig.value_default
        );
      }
    });
  };

  useEffect(fetchConfig, []);

  return (
    <div>
      <Modal isOpen={modal.config} className="modal-dialog">
        <ModalHeader className="bg-primary">
          Configuración para impresión de papeleta
        </ModalHeader>
        <ModalBody>
          <Form
            className="form-horizontal"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
            id="config-form"
          >
            <div className="row">
              <NibbleInput
                md={6}
                label="Tamaño de fuente horizontal:"
                fieldName="horizontalConfig.value_default"
                fieldType="number"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Tamaño de fuente vertical:"
                fieldName="verticalConfig.value_default"
                fieldType="number"
                validation={validation}
                min
              />
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            type="submit"
            form="config-form"
            disabled={isLoading}
          >
            {isLoading && <Spinner size="sm"></Spinner>}{" "}
            <i className="fa fa-save"></i> Guardar Cambios
          </Button>
          <Button color="secondary" onClick={handleClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ConfigModal;
